import { Instance, getRoot, types } from 'mobx-state-tree';
import { MetadataModel } from '../Question/MetadataModel';
import { ValidatorContext, validateSurveyResponse } from '../Survey/surveyResponseValidators';

export interface ResponseContext {
  questionId?: string
  surveyId?: string;
  pathId?: string;
  sessionId?: string;
}

export const Response = types.model('Response', {
  questionId: types.string,
  surveyId: types.maybe(types.string),
  pathId: types.maybe(types.string),
  sessionId: types.maybe(types.string),
  questionKey: types.maybeNull(types.string),
  freeText: types.maybe(types.string),
  value: types.maybe(types.number),
  // TODO check this is used in NewQuestionSession
  valueSonar: types.maybeNull(types.number),
  importance: types.maybe(types.number),
  specialTypeOfAnswer: types.maybe(types.boolean),
  answers: types.optional(types.array(types.model('SurveyResponseAnswer', {
    id: types.string,
    key: types.maybeNull(types.string),
    meta: types.maybeNull(types.array(MetadataModel)),
  })), []),
})
  .views(self => {
    return {
      match(context: ResponseContext): boolean {
        return (
          (context.questionId ? self.questionId === context.questionId : true) &&
          (context.surveyId ? self.surveyId === context.surveyId : true) &&
          (context.pathId ? self.pathId === context.pathId : true) &&
          (context.sessionId ? self.sessionId === context.sessionId : true)
        );
      },
      get valid() {
        const root = getRoot<any>(self);
        const question = root.question.getQuestion(self.questionId);
        const ctx: ValidatorContext = {
          findAnswerKey: (questionKey: string) => {
            // Look up the first answer key for a previously-finalised response
            // in the same survey. Used by chooseTopics validator to read the
            // chooseService selection (serviceTypeId) from earlier in the flow.
            const responses = root.responses?.responses;
            if (!responses) return undefined;
            const match = responses.find((r: any) =>
              r.questionKey === questionKey
              && (self.surveyId ? r.surveyId === self.surveyId : true)
            );
            return match?.answers?.[0]?.key || undefined;
          },
        };
        return validateSurveyResponse(self, question, ctx);
      },
    };
  }  );

export interface IResponse extends Instance<typeof Response> {}
